import React, { useState } from 'react'
import { Row, Col, Button, Modal, ModalBody } from "reactstrap";
import { connect } from 'react-redux';
import { SelectForm } from '../Basicos/index';
import { axiosApi } from '../Basicos/axiosInstances';
import * as actionsRedux from '../Store/Actions/index';

// O e-mail de abertura (Texto 1) só pode ser enviado uma única vez por Período Letivo — a trava
// de verdade é no banco (ComunicadoAberturaSelecaoGrupo.periodo_letivo_id é unique), aqui só
// escondemos da lista quem já foi enviado pra não deixar o usuário nem tentar de novo.
const ModalEnviarComunicadoAberturaSelecaoGrupo = ({ isOpen, toggle, periodosLetivos, periodosLetivosComComunicadoEnviado, ativarAlert }) => {
    const [periodoLetivoId, setPeriodoLetivoId] = useState(undefined);
    const [enviando, setEnviando] = useState(false);

    const opcoes = (periodosLetivos || [])
        .filter(periodoLetivo => !(periodosLetivosComComunicadoEnviado || []).includes(periodoLetivo.id))
        .map(periodoLetivo => ({ value: periodoLetivo.id, label: periodoLetivo.descricao }));

    const fechar = () => {
        setPeriodoLetivoId(undefined);
        toggle();
    }

    const enviar = () => {
        if (!periodoLetivoId) {
            return;
        }

        setEnviando(true);

        axiosApi.post('/alunos/periodo-selecao-grupo/enviar-comunicado-abertura', { periodo_letivo_id: periodoLetivoId })
            .then((resposta) => {
                ativarAlert(201, resposta.data.sucesso);
                fechar();
            })
            .catch((erro) => {
                ativarAlert(400, erro?.response?.data?.erro || 'Não foi possível enviar o e-mail.');
            })
            .finally(() => setEnviando(false));
    }

    return (
        <Modal isOpen={isOpen} toggle={fechar}>
            <ModalBody>
                <Row>
                    <Col xs={12}>
                        <h4>Enviar E-mail de Abertura</h4>
                        <p>Selecione o Período Letivo. O e-mail só pode ser enviado <strong>uma única vez</strong> por período letivo — depois de enviado, ele some dessa lista.</p>
                    </Col>
                    <SelectForm
                        label="Período Letivo"
                        name="periodo_letivo_id"
                        placeholder="Selecione"
                        options={opcoes}
                        onChange={(nome, valor) => setPeriodoLetivoId(valor)}
                        value={opcoes.find(opcao => opcao.value === periodoLetivoId) || ''}
                        style={{ col: { xs: 12 } }}
                        menuPortalTarget={document.body}
                    />
                </Row>

                <Row className="buttons-modal-publicado">
                    <Button onClick={fechar} className="btn-transparente" disabled={enviando}>Cancelar</Button>
                    <Button onClick={enviar} color="primary" disabled={!periodoLetivoId || enviando}>
                        {enviando ? 'Enviando...' : 'Enviar'}
                    </Button>
                </Row>
            </ModalBody>
        </Modal>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        ativarAlert: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao)),
    }
}

export default connect(null, mapDispatchToProps)(ModalEnviarComunicadoAberturaSelecaoGrupo)
